if (!customElements.get('atlas-trip-kit')) {
  const products = new Map();
  const root = () => window.Shopify?.routes?.root || '/';
  const read = async (url, options) => {
    const response = await fetch(url, options);
    const value = await response.json();
    if (!response.ok) throw new Error(value.description || value.error?.message || 'İşlem tamamlanamadı. Tekrar deneyebilirsin.');
    return value;
  };
  const el = (tag, text, cls) => { const node = document.createElement(tag); if (text) node.textContent = text; if (cls) node.className = cls; return node; };
  customElements.define('atlas-trip-kit', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('[data-kit-buy]');
      this.status = this.querySelector('[data-kit-status]');
      this.error = this.querySelector('[data-kit-error]');
      this.button.addEventListener('click', () => this.buy());
      this.load();
    }
    async load() {
      try {
        this.lines = JSON.parse(this.querySelector('[data-kit-lines]').textContent);
        if (!Array.isArray(this.lines) || !this.lines.length) throw new Error('Bu av için henüz takım seçilmedi.');
        const list = el('ul');
        let total = 0, available = true;
        for (const line of this.lines) {
          const url = `${root()}products/${encodeURIComponent(line.handle)}.js`;
          if (!products.has(url)) products.set(url, read(url).catch(error => { products.delete(url); throw error; }));
          const product = await products.get(url);
          const variant = product.variants.find(v => String(v.id) === String(line.variantId));
          const row = el('li');
          if (product.featured_image) { const img = el('img'); img.src = product.featured_image; img.alt = ''; img.width = 64; img.height = 64; img.loading = 'lazy'; row.append(img); }
          const info = el('div');
          const link = el('a', product.title); link.href = `${root()}products/${encodeURIComponent(line.handle)}?variant=${encodeURIComponent(line.variantId)}`;
          info.append(link);
          if (variant && variant.title !== 'Default Title') info.append(el('small', variant.title));
          const ready = variant?.available === true;
          available &&= ready;
          info.append(el('small', `${line.quantity} adet · ${ready ? new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(variant.price / 100) : 'Şu anda satın alınamıyor'}`));
          if (ready) total += variant.price * line.quantity;
          row.append(info); list.append(row);
        }
        this.querySelector('[data-kit-products]').replaceChildren(list);
        if (available) this.querySelector('[data-kit-products]').append(el('p', `Takım toplamı: ${new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(total / 100)}`, 'atlas-trip-kit__total'));
        this.button.disabled = !available;
        if (!available) throw new Error('Takımın bazı ürünleri şu anda satın alınamıyor. Ürünleri ayrı ayrı inceleyebilirsin.');
      } catch (error) { this.error.textContent = error.message; this.error.hidden = false; }
    }
    async buy() {
      if (this.busy) return;
      this.busy = true; this.dataset.busy = 'true'; this.button.disabled = true; this.error.hidden = true;
      const pickup = this.dataset.mode === 'pickup';
      this.status.textContent = 'Takım ve sepet kontrol ediliyor…';
      try {
        let cart = await read(`${root()}cart.js`);
        const marker = pickup ? this.dataset.tripId : `used-${this.dataset.tripId}`;
        const items = this.lines.flatMap(line => {
          const existing = cart.items.filter(item => String(item.variant_id) === String(line.variantId) && item.properties?._atlas_trip_kit === marker).reduce((sum, item) => sum + item.quantity, 0);
          return existing >= line.quantity ? [] : [{ id: line.variantId, quantity: line.quantity - existing, properties: { _atlas_trip_kit: marker } }];
        });
        if (items.length) await read(`${root()}cart/add.js`, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ items }) });
        cart = await read(`${root()}cart.js`);
        if (!pickup) { window.location.assign(`${root()}cart`); return; }
        if (cart.currency !== 'TRY') throw new Error('Av günü teslim ödemesi TL ile yapılır. Mağaza para birimini TL olarak seçip tekrar dene.');
        if (cart.items.some(item => item.selling_plan_allocation || item.gift_card)) throw new Error('Abonelik veya hediye kartı içeren sepet için mağazayla iletişime geç. Sepetindeki ürünler korunuyor.');
        const lines = cart.items.map(item => ({ variantId: String(item.variant_id), quantity: item.quantity, attributes: Object.entries(item.properties || {}).filter(([, value]) => value !== null && value !== '').map(([key, value]) => ({ key, value: String(value) })) }));
        const discountCodes = (cart.discount_codes || []).filter(code => code.applicable).map(code => code.code);
        const fingerprint = JSON.stringify({ trip: this.dataset.tripId, lines, discountCodes });
        // Keep the retry id across reloads; never clear the customer's cart before payment.
        let saved = this.checkoutAttempt; try { saved = JSON.parse(sessionStorage.getItem('atlas-trip-checkout') || 'null') || saved; } catch { /* Storage may be blocked. */ }
        if (!saved || saved.fingerprint !== fingerprint) saved = { fingerprint, id: crypto.randomUUID() };
        this.checkoutAttempt = saved;
        try { sessionStorage.setItem('atlas-trip-checkout', JSON.stringify(saved)); } catch { /* The current click still works. */ }
        this.status.textContent = 'Sepetinin tamamı için ücretsiz av günü teslim ödemesi hazırlanıyor…';
        const result = await read('https://ops.atlasav.com.tr/api/v1/public/trip-checkout', { method: 'POST', credentials: 'omit', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ id: saved.id, tripId: this.dataset.tripId, lines, discountCodes }), signal: AbortSignal.timeout(45000) });
        const url = new URL(result.data.checkoutUrl);
        if (url.protocol !== 'https:' || !['gf0njb-9v.myshopify.com', 'atlasav.com.tr', 'www.atlasav.com.tr'].includes(url.hostname)) throw new Error('Ödeme adresi doğrulanamadı.');
        window.location.assign(url.href);
      } catch (error) {
        this.error.textContent = error.name === 'TimeoutError' || error.name === 'TypeError' ? 'Bağlantı doğrulanamadı. Sepetin korunuyor; aynı düğmeyle tekrar deneyebilirsin.' : error.message;
        this.error.hidden = false; this.status.textContent = ''; this.button.disabled = false;
      } finally { this.busy = false; delete this.dataset.busy; }
    }
  });
}
